import { dropdown, displaySelectedValue } from '../../../dropdown';
import { showToast } from '../../../toasts';
import { PAGE_LOADER, DASHBOARD_CONTAINER } from'../../../../types/types';
import { TERMINAL_FORM, BILLING_TYPE, TERMINAL_PUBLIC, TERMINAL_STATUS, STATE_ABBR } from '../form-terminal-types';

import { INewPartner } from '../../../../models/partner.interface';
import GetPartners from '../../../../routes/get-partners';
import GetNextTerminalID from '../../../../routes/get-next-terminalid';

import { addNewTerminal } from './add-new-terminal';

/**
 * Handles the AWS api response to get partner and next terminal id data
 * and call the function to add a new terminal.
 * 
 * @returns void
 */
const HandleNewTerminalForm = async () => {
  if(!TERMINAL_FORM.terminalForm) return;

  const [ partner, nextID ] = await Promise.all([GetPartners(), GetNextTerminalID()]);

  const { body } = partner;  
  const { body: { newTerminalID } } = nextID;

  TERMINAL_FORM.terminalName.value = newTerminalID;

  if ( body ) {
    const mapList = body.map(({ partnerID, partnerName }) => ({ id: partnerID, name: partnerName }));
    dropdown(mapList, 'partner', 'Partner', true, true, true);
    DASHBOARD_CONTAINER.removeAttribute('style');
    PAGE_LOADER.loaderContainer.classList.add('aafp_no-show');
  } else {
    showToast('aafp_toast-alert', 'Unable to load partner data.');
  }

  dropdown(BILLING_TYPE, 'one', 'Billing Type', false, true, true);
  dropdown(TERMINAL_STATUS, 'two', 'Status', false, true, true);
  dropdown(TERMINAL_PUBLIC, 'public', 'Public', false, true, true);
  dropdown(STATE_ABBR, 'state', 'State', true, true, true);

  displaySelectedValue('.aafp_list-two', 'two', '1');

  const partnerSelect = TERMINAL_FORM.terminalPartnerSelect;
  const Observer = new MutationObserver((mutRecords: any) => {
    for (const mutation of mutRecords) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'data-value') {
        if (mutation.target.getAttribute('data-value')) {
          const fields = Array.from(document.querySelectorAll<HTMLElement>('.aafp_required-input'));
          fields.forEach((ele) => {
            const tagNames = ele.getAttribute('name');
            if (tagNames === '') {
              ele.removeAttribute('disabled');
            }
            if (tagNames !== '') {
              ele.removeAttribute('disabled');
              ele.setAttribute('required', 'required');
            }
          });
        }
        return;
      }
    }
  });

  Observer.observe(partnerSelect, { attributes: true });

  addNewTerminal();
}

export default HandleNewTerminalForm;